import React, { useState } from 'react';
import LocalAvailabilityDataTable from 'components/masterCatalog/localAvailability/LocalAvailabilityDataTable';
import { getFromLocalStorage } from 'localStorageService/LocalStorage';

const TotalCatalogPage = () => {
  const [inputValues, setInputValues] = useState({
    catalogPage: 6,
    page: 1,
    opsId: getFromLocalStorage('opsId'),
    key: '',
    type: -1,
    stock: -1,
    productionline: 0,
    productdefination: -1,
    status: -1,
    qty: -1,
    categories: '',
    priceTo: '',
    originOps: 0,
    inventoryBarcode: '',
  });

  return (
    <div className="toolbar-table-style">
      <LocalAvailabilityDataTable
        inputValues={inputValues}
        setInputValues={setInputValues}
        title="Total"
        isTotalCatalog={true}
      />
    </div>
  );
};

export default TotalCatalogPage;
